import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Bouton de navigation précédent/suivant à placer en haut des pages détail.
 * Utilise le hook usePrevNextNav.
 */
export default function PrevNextNav({ prev, next, goPrev, goNext, index, total, className = '' }) {
  if (!total || total <= 1) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="prev-next-nav">
      <Button variant="outline" size="sm" onClick={goPrev} disabled={!prev}
        data-testid="prev-nav-btn" title="Précédent (←)">
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <span className="text-xs text-slate-500 font-mono min-w-[60px] text-center">
        {index >= 0 ? `${index + 1} / ${total}` : `? / ${total}`}
      </span>
      <Button variant="outline" size="sm" onClick={goNext} disabled={!next}
        data-testid="next-nav-btn" title="Suivant (→)">
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}
